import React from "react"

export const AgentInfo = ({agent}) => {
  if(agent.profile_url){
    return(
      <div className="agent-details">
        <a href={agent.profile_url} target="_blank">
          {
            agent.avatar &&
            <div className="avatar" style={{ backgroundImage: `url(${agent.avatar})` }}></div>
          }
        </a>
        <div className="content">
          <div className="name">
            <a href={agent.profile_url} target="_blank">
              {agent.first_name+' '+agent.last_name}
            </a>
            {agent.phone &&
              <span><br /><a href={'tel:'+agent.phone}>{agent.phone}</a></span>}
            {agent.email &&
              <span><br /><a href={'mailto:'+agent.email} target="_blank">Email Me</a></span>}
            {agent.profile_url &&
              <span><br /><a href={agent.profile_url} target="_blank">View My Profile</a></span>}
          </div>
        </div>
      </div>
    )
  }else{
    return(
      <div className="agent-details">
        {
          agent.avatar &&
          <div className="avatar" style={{ backgroundImage: `url(${agent.avatar})` }}></div>
        }
        <div className="content">
          <div className="name">
            {agent.first_name+' '+agent.last_name}
            {agent.phone &&
              <span><br />{agent.phone}</span>}
            {agent.email &&
              <span><br /><a href={'mailto:'+agent.email} target="_blank">Email Me</a></span>}
          </div>
        </div>
      </div>
    )
  }
}
const AgentDetails = (props) => {

    const agent = props.agent;
    const secondaryAgent = props.secondaryAgent;


    const secondaryAgentInfo = () => {
        if(secondaryAgent.id){
            if(secondaryAgent.profile_url){
                return(
                    <div className="agent-details">
                        <a href={secondaryAgent.profile_url} target="_blank">
                            {
                                secondaryAgent.avatar &&
                                <div className="avatar" style={{ backgroundImage: `url(${secondaryAgent.avatar})` }}></div>
                            }
                        </a>
                        <div className="content">
                            <div className="name">
                                <a href={secondaryAgent.profile_url} target="_blank">
                                    {secondaryAgent.first_name+' '+secondaryAgent.last_name}
                                </a>
                                {secondaryAgent.phone &&
                                    <span><br /><a href={'tel:'+secondaryAgent.phone}>{secondaryAgent.phone}</a></span>}
                                {secondaryAgent.email &&
                                    <span><br /><a href={'mailto:'+secondaryAgent.email} target="_blank">Email Me</a></span>}
                                {secondaryAgent.profile_url &&
                                    <span><br /><a href={secondaryAgent.profile_url} target="_blank">View My Profile</a></span>}
                            </div>
                        </div>
                    </div>
                )
            }else{
                return(
                    <div className="agent-details">
                        {
                            secondaryAgent.avatar &&
                            <div className="avatar" style={{ backgroundImage: `url(${secondaryAgent.avatar})` }}></div>
                        }
                        <div className="content">
                            <div className="name">
                                {secondaryAgent.first_name+' '+secondaryAgent.last_name}
                                {secondaryAgent.phone &&
                                    <span><br />{secondaryAgent.phone}</span>}
                                {secondaryAgent.email &&
                                        <span><br /><a href={'mailto:'+secondaryAgent.email} target="_blank">Email Me</a></span>}
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    if(agent.id){
      return (
          <div>
              {agent.id &&
                  <div>Presented By:</div>}
                  <AgentInfo agent={agent} />
                  {secondaryAgentInfo()}
          </div>
      )
    } else {
      return null;
    }
}

export default AgentDetails
